import './App.css';
import {createTheme, ThemeProvider} from '@material-ui/core/styles';
import PatentSearch from "./components/PatentSearch";
import React from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
//import {getPrimaryColor, isKNK} from "./api/config";




const theme = createTheme({
    palette: {
        primary: {
            main: "#AB5212",
        },
        secondary: {
            main: "#AB5215"
        },
    },

    overrides: {
        MuiButton: {
            root: {
                borderRadius: 0,
            },
        },
        MuiOutlinedInput: {
            root: {
                borderRadius: 0,
            },
        },
        MuiPaper:{
            rounded:{
                borderRadius:0,
            },
        },
        MuiChip:{
            sizeSmall:{
                borderRadius:0
            }
        }
    },
});

function App() {
    return (
        <ThemeProvider theme={theme}>
            <Navbar/>
          <div className="p-2 py-6 max-w-4xl mx-auto flex flex-col min-h-screen">
                <PatentSearch/>
            </div>
            <Footer/>
        </ThemeProvider>
    );
}

export default App;
